import axios from "axios";
import logger from "./logService";
import { toast } from "react-toastify";

axios.interceptors.response.use(null, error => {
  const expectedError =
    error.response &&
    error.response.status >= 400 &&
    error.response.status < 500;

  if (!expectedError) {
    logger.log(error);
    toast.error("An unexpected error occurred.");
  } else {
    const { data } = error.response;

    var errors = "";
    if (data !== "null") {
      for (var propName in data) {
        if (data.hasOwnProperty(propName)) {
          const propValue = data[propName];
          errors += `${propName} : ${propValue[0]}\n`;
        }
      }
      toast.error(errors);

      if (errors.includes("invoices header with this sequence already exists")) {
        error.message = "invoice sequence duplicated";
      }
    }
  }

  return Promise.reject(error);
});

function setJwt(jwt) {
  axios.defaults.headers.common["x-auth-token"] = jwt;
}

export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  setJwt
};
